<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('auth.reset_password') }}</h4>
                  <p>{{ $t('messages.reset_password') }}</p>
                </div>

                <div class="clearfix">
                  <vs-input
                    v-validate="'required|regex:^[0-9]{4}$'"
                    data-vv-validate-on="blur"
                    name="confirmationCode"
                    :label-placeholder="$t('auth.confirm_code')"
                    :data-vv-as="$t('auth.confirm_code')"
                    v-model="confirmationCode"
                    @keyup="confirmationCode = translateNumbers(confirmationCode)"
                    class="w-full"
                  />
                  <span class="text-danger text-sm">{{ errors.first('confirmationCode') }}</span>

                  <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input
                        ref="password"
                        type="password"
                        data-vv-validate-on="blur"
                        v-validate="'required|min:8'"
                        name="password"
                        :label-placeholder="$t('users.password')"
                        :data-vv-as="$t('users.password')"
                        v-model="password"
                        class="w-full mt-6"
                      />
                      <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input
                        type="password"
                        v-validate="'min:8|confirmed:password'"
                        data-vv-validate-on="blur"
                        name="confirmPassword"
                        :label-placeholder="$t('auth.confirm_password')"
                        :data-vv-as="$t('auth.confirm_password')"
                        v-model="confirmPassword"
                        class="w-full mt-6"
                      />
                      <span class="text-danger text-sm">{{ errors.first('confirmPassword') }}</span>
                    </div>
                  </div>

                  <vs-alert :active="countDown !== 0" icon="warning" color="warning" class="my-5">
                    <span>{{ countDown }}&ensp;{{ $t('messages.resend_code') }}</span>
                  </vs-alert>

                  <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row mt-6">
                    <vs-button
                      :disabled="countDown !== 0"
                      @click="resetCountDown"
                      type="border"
                      class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                      >{{ $t('button.resend_code') }}</vs-button
                    >
                    <vs-button @click="resetPassword" :disabled="!validateForm" class="w-full sm:w-auto">
                      {{ $t('button.reset_and_log_in') }}
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { TranslateNumbers } from '@/utils'

export default {
  data() {
    return {
      confirmationCode: '',
      password: '',
      confirmPassword: '',
      countDown: 60 * 2
    }
  },
  created() {
    this.countDownTimer()
  },
  computed: {
    username() {
      return this.$route.params.phone
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.confirmationCode !== '' &&
        this.password !== '' &&
        this.confirmPassword !== ''
      )
    }
  },
  methods: {
    resendConfirmationCode() {
      const payload = {
        username: this.username
      }

      this.$store
        .dispatch('auth/forgetPassword', payload)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.$notifySuccess(this.$t('messages.verification_sent'))
        })
    },
    resetPassword() {
      const payload = {
        code: this.confirmationCode,
        username: this.username,
        password: this.password
      }

      this.$store
        .dispatch('auth/resetPassword', payload)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          const loginPayload = {
            checkbox_remember_me: false,
            userDetails: {
              phone: this.username,
              password: this.password
            }
          }
          this.$store
            .dispatch('auth/loginJWT', loginPayload)
            .then(() => this.$router.push({ name: 'dashboard' }))
            .catch(() => this.$router.push({ name: 'page-login' }))
        })
    },
    resetCountDown() {
      this.countDown = 60 * 2
      this.countDownTimer()
      this.resendConfirmationCode()
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    translateNumbers(val) {
      return TranslateNumbers(val)
    }
  }
}
</script>
